module.exports = __webpack_public_path__ + "static/media/protection-card.7058feb0.wav";